document.addEventListener("DOMContentLoaded", () => {
  const customizers = document.querySelectorAll("[data-fin-embroidery]");

  customizers.forEach((customizer) => {
    const checkbox = customizer.querySelector("[data-fin-enable]");
    const panel = customizer.querySelector("[data-fin-panel]");

    const input = customizer.querySelector(
      ".fin-personalization-input"
    );

    const counter = customizer.querySelector(
      "[data-fin-character-count]"
    );
    const personalizationHelp = customizer.querySelector(
  "[data-fin-personalization-help]"
);

    const previewText = customizer.querySelector(
      "[data-fin-preview-text]"
    );
    const productSection =
  customizer.closest("product-info") ||
  customizer.closest(".product");

const mainMediaItem =
  productSection?.querySelector(".product__media-item");

const mainImageContainer =
  mainMediaItem?.querySelector(".product-media-container") ||
  mainMediaItem?.querySelector(".media");

let photoEmbroideryText = null;
const embroideryTypeClasses = [
   "fin-embroidery--duffle-low",
   "fin-embroidery--duffle",
   "fin-embroidery--duffle-small-low",
   "fin-embroidery--tote-left",
   "fin-embroidery--tote-small-center",
  "fin-embroidery--tote",
  "fin-embroidery--oversized",
  "fin-embroidery--vanity",
  "fin-embroidery--vanity-center",
  "fin-embroidery--laptop"
];

const embroideryTypeClass =
  embroideryTypeClasses.find((className) =>
    customizer.classList.contains(className)
  );

if (embroideryTypeClass && mainImageContainer) {
  mainImageContainer.classList.add(embroideryTypeClass);
}

if (mainImageContainer) {
  mainImageContainer.style.position = "relative";

  photoEmbroideryText = document.createElement("div");
  photoEmbroideryText.className = "fin-photo-embroidery";
  photoEmbroideryText.hidden = true;

  mainImageContainer.appendChild(photoEmbroideryText);
}
    const fontInputs = Array.from(
      customizer.querySelectorAll("[data-fin-font]")
    );

    const threadInputs = Array.from(
      customizer.querySelectorAll("[data-fin-thread]")
    );
const cartText = customizer.querySelector("[data-fin-cart-text]");
const cartFont = customizer.querySelector("[data-fin-cart-font]");
const cartThreadName = customizer.querySelector("[data-fin-cart-thread-name]");
const cartThreadCode = customizer.querySelector("[data-fin-cart-thread-code]");
    const fontError = customizer.querySelector(
      "[data-fin-font-error]"
    );

    const threadError = customizer.querySelector(
      "[data-fin-thread-error]"
    );

    const textError = customizer.querySelector(
      "[data-fin-text-error]"
    );
const updateCartProperties = () => {
  const selectedFont = fontInputs.find((fontInput) => fontInput.checked);
  const selectedThread = threadInputs.find((threadInput) => threadInput.checked);

  const threadOption = selectedThread?.closest(".fin-thread-option");
  const threadName = threadOption
    ?.querySelector(".fin-thread-option__name")
    ?.textContent.trim();

  if (cartText) {
    cartText.value = input ? input.value.trim() : "";
  }

  if (cartFont) {
    cartFont.value = selectedFont ? selectedFont.value : "";
  }

  if (cartThreadName) {
    cartThreadName.value = threadName || "";
  }

  if (cartThreadCode) {
    cartThreadCode.value = selectedThread ? selectedThread.value : "";
  }
};
const addEmbroideryFee = async () => {
  if (!checkbox?.checked) return;

  try {
    await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        items: [
          {
            id: 52417586626840,
            quantity: 1
          }
        ]
      })
    });
  } catch (error) {
    console.error("Fin & Fern embroidery fee error:", error);
  }
};
    const productForm = customizer.closest("form");

    if (!checkbox || !panel) return;

    /*
    -------------------------------------------------------
    Stage 1 — Open and close personalization panel
    -------------------------------------------------------
    */

    const updatePanel = () => {
      const isEnabled = checkbox.checked;

      panel.hidden = !isEnabled;

      const panelFields = panel.querySelectorAll(
        "input, select, textarea"
      );

      panelFields.forEach((field) => {
        field.disabled = !isEnabled;
      });
if (!isEnabled) {
  clearAllErrors();

  if (photoEmbroideryText) {
    photoEmbroideryText.hidden = true;
  }
}
    };

    /*
    -------------------------------------------------------
    Stage 4 — Character counter
    -------------------------------------------------------
    */

    const updateCharacterCount = () => {
      if (!input || !counter) return;

      counter.textContent =
        `${input.value.length} / ${input.maxLength} characters`;
    };

    /*
  /*
------------------------------------------------------------
Stage 5 – Temporary font preview settings
------------------------------------------------------------
*/

const fontStyles = {
  "Heritage": 'Georgia, "Times New Roman", serif',
  "Hayden": '"Hayden Font", cursive',
  "Fishtale": '"Fish tale Font", cursive',
  "Varsity": '"Varsity Font", sans-serif',
  "Classic": '"Classic Font", serif',
  "Engrave": '"Engrave", serif',
  "Vine": '"Vine", serif',
  "Cambridge": "'Cambridge', serif",
 "Fishtale Monogram": "'FishtaleMonogram', serif",
 "DiamondMonogram": "'DiamondMonogram', serif",
 "CircleMonogram": "'CircleMonogram', serif",
 "EngraveMonogram": '"Engrave", serif'
};
const uppercaseOnlyFonts = [
  "Fishtale",
  "Engrave",
  "Varsity"
];
const isMonogramFont = (fontInput) => {
  return fontInput?.dataset.finMonogram === "true";
};
/*
------------------------------------------------------------
Stage 5 – Thread color preview settings
------------------------------------------------------------
*/

const threadColors = {
  "White": "#FFFFFF",
  "Light Blue": "#80BDDA",
  "Navy": "#17355D",
  "Pink": "#DBA6B6"
};/*
    -------------------------------------------------------
    Stage 5 — Update live preview
    -------------------------------------------------------
    */

   const updatePreview = () => {
  if (!previewText) return;

  const enteredText = input
    ? input.value.trim()
    : "";

  const selectedFont = fontInputs.find(
    (fontInput) => fontInput.checked
  );

  const selectedThread = threadInputs.find(
    (threadInput) => threadInput.checked
  );

  const monogramSelected =
    selectedFont && isMonogramFont(selectedFont);

  const selectedFontFamily = selectedFont
    ? fontStyles[selectedFont.value] ||
      'Georgia, "Times New Roman", serif'
    : 'Georgia, "Times New Roman", serif';

    previewText.classList.remove("fin-monogram-preview");
if (monogramSelected) {
  const monogramText =
    enteredText.length > 0
      ? enteredText.slice(0, 3)
      : "ABC";

  if (selectedFont?.value === "DiamondMonogram") {
    const leftLetter =
      (monogramText[0] || "").toLowerCase();

    const middleLetter =
      (monogramText[1] || "").toUpperCase();

    const rightLetter =
      (monogramText[2] || "").toUpperCase();

    const rightIndex = rightLetter.charCodeAt(0) - 65;

    const rightGlyph =
      rightIndex >= 0 && rightIndex < 26
        ? String.fromCodePoint(0xE001 + rightIndex)
        : "";

    previewText.textContent =
  leftLetter + middleLetter + rightGlyph;

} else if (selectedFont?.value === "CircleMonogram") {
  const leftLetter =
    (monogramText[0] || "").toLowerCase();

  const middleLetter =
    (monogramText[1] || "").toUpperCase();

  const rightLetter =
    (monogramText[2] || "").toUpperCase();

  const rightIndex = rightLetter.charCodeAt(0) - 65;

  const rightGlyph =
    rightIndex >= 0 && rightIndex < 26
      ? String.fromCodePoint(0xE001 + rightIndex)
      : "";

  previewText.textContent =
    leftLetter + middleLetter + rightGlyph;

} else if (selectedFont?.value === "EngraveMonogram") {
  const engraveLetters =
    monogramText
      .slice(0, 3)
      .toUpperCase()
      .split("");

  previewText.textContent = engraveLetters.join("-");

  } else {
    const formattedMonogram =
      (monogramText[0] || "").toLowerCase() +
      (monogramText[1] || "").toUpperCase() +
      (monogramText[2] || "").toLowerCase();

    previewText.textContent = formattedMonogram;
  }

} else {
  const displayText =
    enteredText.length > 0
      ? enteredText
      : "ABC";

  previewText.textContent =
    uppercaseOnlyFonts.includes(selectedFont?.value)
      ? displayText.toUpperCase()
      : displayText;
}

previewText.style.fontFamily = selectedFontFamily;

  if (selectedThread) {
  const selectedSwatch = selectedThread
    .closest(".fin-thread-option")
    ?.querySelector(".fin-thread-option__circle");

  const selectedColor = selectedSwatch
    ?.style.getPropertyValue("--fin-thread-color")
    .trim();

  previewText.style.color = selectedColor || "#17355D";
}
if (photoEmbroideryText) {
  photoEmbroideryText.textContent = previewText.textContent;
  photoEmbroideryText.style.fontFamily = previewText.style.fontFamily;
  photoEmbroideryText.style.color = previewText.style.color;

  photoEmbroideryText.classList.toggle(
    "fin-monogram-preview",
    previewText.classList.contains("fin-monogram-preview")
  );

  const hasText = enteredText.length > 0;

  photoEmbroideryText.hidden = !hasText;
}
};
    const updateInputMode = () => {
  if (!input) return;

  const selectedFont = fontInputs.find(
    (fontInput) => fontInput.checked
  );

  const monogramSelected =
    selectedFont && isMonogramFont(selectedFont);

  if (monogramSelected) {
    input.maxLength = 3;
    input.placeholder = "Enter 3 initials";

if (selectedFont?.value === "EngraveMonogram") {
  input.setAttribute("autocomplete", "off");
  input.setAttribute("autocorrect", "off");
  input.setAttribute("autocapitalize", "off");
  input.setAttribute("spellcheck", "false");
} else {
  input.removeAttribute("autocomplete");
  input.removeAttribute("autocorrect");
  input.removeAttribute("autocapitalize");
  input.removeAttribute("spellcheck");
}

    if (personalizationHelp) {
  personalizationHelp.textContent =
    selectedFont?.value === "EngraveMonogram"
      ? "3 letters — First, Middle, Last"
      : "3 letters — First, Last, Middle";
}

    if (input.value.length > 3) {
      input.value = input.value.slice(0, 3);
    }
  } else {
    input.maxLength = 6;
    input.placeholder = "Enter up to 6 letters";

    if (personalizationHelp) {
  personalizationHelp.textContent =
    "1–6 letters";
}
  }

  updateCharacterCount();
};  

    /*
    -------------------------------------------------------
    Stage 6 — Validation helpers
    -------------------------------------------------------
    */

    const setRadioError = (radioInputs, errorElement, hasError) => {
      radioInputs.forEach((radioInput) => {
        if (hasError) {
          radioInput.setAttribute("aria-invalid", "true");
        } else {
          radioInput.removeAttribute("aria-invalid");
        }
      });

      if (errorElement) {
        errorElement.hidden = !hasError;
      }
    };

    const setTextError = (hasError) => {
      if (input) {
        if (hasError) {
          input.setAttribute("aria-invalid", "true");
        } else {
          input.removeAttribute("aria-invalid");
        }
      }

      if (textError) {
        textError.hidden = !hasError;
      }
    };

    function clearAllErrors() {
      setRadioError(fontInputs, fontError, false);
      setRadioError(threadInputs, threadError, false);
      setTextError(false);
    }

    /*
    -------------------------------------------------------
    Stage 6 — Validate personalization selections
    -------------------------------------------------------
    */

    const validatePersonalization = () => {
      if (!checkbox.checked) {
        clearAllErrors();
        return true;
      }

      const selectedFont = fontInputs.some(
        (fontInput) => fontInput.checked
      );

      const selectedThread = threadInputs.some(
        (threadInput) => threadInput.checked
      );

      const selectedFontInput = fontInputs.find(
  (fontInput) => fontInput.checked
);

const monogramSelected =
  selectedFontInput &&
  isMonogramFont(selectedFontInput);

const personalizationLength =
  input ? input.value.trim().length : 0;

const hasPersonalizationText =
  monogramSelected
    ? personalizationLength === 3
    : personalizationLength >= 1 &&
      personalizationLength <= 6;

      setRadioError(
        fontInputs,
        fontError,
        !selectedFont
      );

      setRadioError(
        threadInputs,
        threadError,
        !selectedThread
      );

      setTextError(!hasPersonalizationText);

      if (!selectedFont) {
        fontInputs[0]?.focus();
        fontInputs[0]?.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });

        return false;
      }

      if (!selectedThread) {
        threadInputs[0]?.focus();
        threadInputs[0]?.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });

        return false;
      }

      if (!hasPersonalizationText) {
        input?.focus();
        input?.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });

        return false;
      }

      return true;
    };

    /*
    -------------------------------------------------------
    Event listeners
    -------------------------------------------------------
    */

    checkbox.addEventListener("change", updatePanel);

    if (input) {
      input.addEventListener("input", () => {
        const selectedFont = fontInputs.find(
  (fontInput) => fontInput.checked
);

if (uppercaseOnlyFonts.includes(selectedFont?.value)) {
  input.value = input.value.toUpperCase();
}
        updateCharacterCount();
        updatePreview();
        updateCartProperties();

        if (input.value.trim().length > 0) {
          setTextError(false);
        }
      });
    }

  fontInputs.forEach((fontInput) => {
  fontInput.addEventListener("change", () => {
    updateInputMode();
    updatePreview();
    updateCartProperties();
    setRadioError(fontInputs, fontError, false);
  });
  
    });

    threadInputs.forEach((threadInput) => {
  threadInput.addEventListener("change", () => {
    updatePreview();
    updateCartProperties();
    setRadioError(threadInputs, threadError, false);

    const option = threadInput.closest(".fin-thread-option");

    if (option) {
      option.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center"
      });
    }
  });
});
    /*
    -------------------------------------------------------
    Stop Add to Cart when required information is missing
    -------------------------------------------------------
    */
if (productForm) {
  productForm.addEventListener(
    "submit",
    (event) => {
      const isValid = validatePersonalization();

      if (!isValid) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );
}
/* ------------------------------------------------------------
   Thread Color Carousel
------------------------------------------------------------ */

document.querySelectorAll(".fin-embroidery__carousel").forEach((carousel) => {
  const swatches = carousel.querySelector(".fin-embroidery__swatches");
  const prevButton = carousel.querySelector("[data-fin-thread-prev]");
  const nextButton = carousel.querySelector("[data-fin-thread-next]");

  if (!swatches || !prevButton || !nextButton) return;

  const getScrollAmount = () => {
  const firstOption = swatches.querySelector(".fin-thread-option");

  if (!firstOption) return 100;

  const styles = window.getComputedStyle(swatches);
  const gap = parseFloat(styles.columnGap || styles.gap) || 0;

  return firstOption.getBoundingClientRect().width + gap;
};

  prevButton.addEventListener("click", () => {
    swatches.scrollBy({
      left: -getScrollAmount(),
      behavior: "smooth"
    });
  });

  nextButton.addEventListener("click", () => {
    swatches.scrollBy({
      left: getScrollAmount(),
      behavior: "smooth"
    });
  });
});
    /*
    -------------------------------------------------------
    Initial setup
    -------------------------------------------------------
    */

    updatePanel();
updateInputMode();
updateCharacterCount();
updatePreview();
updateCartProperties();
 
});
});